import React, { Component } from 'react';
import './login.css';
import rainmakerLogo from '../assets/esp-rainmaker-text.png'
import logo from '../assets/rainmakercloud.png'
import google from '../assets/google-logo.png'
import github from '../assets/github.png'
import apple from '../assets/apple-logo.png'
class Login extends Component {

    state = {
        error: '',
        api: '',
        githubLink: '',
        googleLink: ''
    }

    componentDidMount() {
        let link = new URLSearchParams(window.location.search);
        let portno;

        const apiUrl = link.get("host_url");
        let pageUrl = link.get("github_url");
        const github = `${pageUrl}identity_provider=GitHub`;
        const google = `${pageUrl}identity_provider=Google`;
        const apple = `${pageUrl}identity_provider=SignInWithApple`;
        const redirect_uri = link.get("redirect_uri");
        const response_type = link.get("response_type");
        const client_id = link.get("client_id");
        const scope = link.get("scope");
        const port = link.get("state");
        if (port) {
            portno = port.split(":")[1];
        }

        this.setState({
            api : `${apiUrl}`,
            githubLink : `${github}&redirect_uri=${redirect_uri}&response_type=${response_type}&client_id=${client_id}&scope=${scope}&state=${port}`,
            googleLink : `${google}&redirect_uri=${redirect_uri}&response_type=${response_type}&client_id=${client_id}&scope=${scope}&state=${port}`,
            appleLink : `${apple}&redirect_uri=${redirect_uri}&response_type=${response_type}&client_id=${client_id}&scope=${scope}&state=${port}`,
            port: portno ? portno : 9000
        }) 
    }

    handleLogin = (event) => {
        event.preventDefault();
        let uname = event.target.username.value;
        let psw = event.target.password.value;
        
        if (uname.length === 0 || psw.length === 0) {
            this.setState({
                error: 'Username or Password cannot be blank'
            })
        } else {
            (this.state.api.length > 0) && fetch(this.state.api, {
                method: "post",
                mode: 'cors',
                body: JSON.stringify({
                    user_name: uname,
                    password: psw
                })
                })
                .then(data => data.json())
                .then(res => {
                    if(res.status === 'success') {
                        console.log("success:", res);
                        let accessToken = res.accesstoken;
                        let idToken = res.idtoken;
                        let refreshToken = res.refreshtoken;
                        let new_redirectURL = `http://localhost:${this.state.port}?access_token=${accessToken}&id_token=${idToken}&refresh_token=${refreshToken}&token_type=Bearer&expires_in=3600` 
                        window.location = new_redirectURL
                        
                        return null;
                    } else {
                        this.setState({
                            error : res.description
                        },  console.log("resp error:", res.description))
                    }
                })
                .catch(error => {
                    this.setState({
                        error : error
                    }, console.log("Error:", error))
                })

        }
    }

    render() {
        return (
            <div className="wrapper">
                <div className="login-card">
                    <div className="login-card-header">
                        <img src={logo} alt="ESP RAINMAKER" className="cloudlogo" />
                        <img src={rainmakerLogo} alt="ESP RAINMAKER" className="logo" />
                    </div>
                    <div className="login-card-body">
                        <a 
                            href={this.state.githubLink} 
                            className="btn github-btn"
                        >
                            <img src={github} className="icon" alt="github" />
                            <span>Sign in with GitHub</span>
                        </a>
                        <a 
                            href={this.state.appleLink} 
                            className="btn github-btn"
                        >
                            <img src={apple} className="apple" alt="apple" />
                            <span>Sign in with Apple</span>
                        </a>
                        <a 
                            href={this.state.googleLink} 
                            className="btn github-btn"
                        >
                            <img src={google} className="icon" alt="google" />
                            <span>Sign in with Google</span>
                        </a>
                    </div>
                    <div className="login-card-body">
                        <p className="muted-text">or Sign in with email</p>
                        <form onSubmit={(e) => this.handleLogin(e)} className="my-4">
                            <div className="form-row">
                                <input type="email" className="form-control" id="username" aria-describedby="emailHelp" placeholder="Email"
                                name="username"/>
                            </div>
    
                            <div className="form-row">
                                <input type="password" className="form-control" id="password" aria-describedby="pswHelp" placeholder="Password"
                                name="password"/>
                            </div>

                            <p className="muted-text text-left mt-2">By signing in , you agree to our <a href="https://rainmaker.espressif.com/docs/terms-of-use.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://rainmaker.espressif.com/docs/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</p>
                            
                            <div className="form-row">
                                <button className="btn login-btn" >Sign in</button>
                            </div>

                            { this.state.error.length > 0 ? <p className="text-danger mt-4">{this.state.error}</p> : ''}
                            
                        </form>
                    </div>
                </div>

                            
            </div>
          );
    }
}

export default Login;
